module.exports = __webpack_public_path__ + "static/img/Seo.02b72376.svg";